const AUTH = "/auth";
export const VERIFY_EMAIL = token => `${AUTH}/verify-email/${token}`;
export const LOGIN = `${AUTH}/login`;
export const FORGOT_PASSWORD = `${AUTH}/forgot-password`;
export const RESET_PASSWORD = `${AUTH}/reset-password`;
export const RESEND_EMAIL_VERIFICATION = `${AUTH}/resend-email-verification`;
export const VERIFY_PHONENUMBER = otp => `bankaccounts/verifyphone/${otp}`;
export const REGISTER = `${AUTH}/register`;

const USER = "/investors";
export const CHANGE_PASSWORD = `${USER}/change-password`;
export const CHANGE_EMAIL = `${USER}/change-email`;
export const CHANGE_PHONENUMBER = `${USER}/change-phone-no`;
export const CHANGE_PHOTO = `${USER}/change-photo`;
export const DASHBOARD = `${USER}/dashboard`;
export const PROFILE = `${USER}/profile`;
export const REFERRAL_DATA = `${USER}/referral-data`;
export const REFERRALS = `${USER}/referrals`;
export const GET_REFERRER_VIA_CODE = code =>
  `${USER}/get-name?referralcode=${code}`;

export const INVESTMENTS = "/investments";
export const WALLET = "/wallet";
export const WITHDRAW = `${WALLET}/withdraw`;
export const TOPUP = `${WALLET}/topup`;
export const PAYOUTS = `${WALLET}/payouts`;
export const SLOTS = "/slots";
export const NO_OF_SLOTS = "/slots/no-of-slots";
export const GET_ACTIVE_PACKAGES = "/packages/active";
export const GET_SOLD_OUT_PACKAGES = "/packages/soldout";
export const GET_FARMSERVISE_COST = "/investments/active-farm-locations";

export const TOGGLE_BALANCE = `/investors/toggle-balance`;
export const BALANCE_STATUS = `/investors/balance-status`

export const MANUAL_PAYMENT = "payments/manual";
export const FARM_SERVICES = "investments/farmservices";

export const TRANSACTIONS = "/transactions";
export const INVEST_FROM_WALLET = `${TRANSACTIONS}/invest-from-wallet`;
export const VERIFY_TRANSACTION = (reference, id) =>
  `${TRANSACTIONS}/verify-transaction/${id}/${reference}`;

export const BANK_ACCOUNTS = "bankaccounts";
export const ADD_BANK_ACCOUNT = `${BANK_ACCOUNTS}/addbank`;
export const DELETE_BANK_ACCOUNT = `${BANK_ACCOUNTS}/deletebank`;
export const RESOLVE_BANK_ACCOUNT = (accountnumber, bankcode) =>
  `${BANK_ACCOUNTS}/resolve-nuban/${accountnumber}/${bankcode}`;
export const REQUEST_OTP = purpose => `${BANK_ACCOUNTS}/generatepin/${purpose}`;

export const PAY = reference => `/wallet/wealthsummit/${reference}`;

export const EVENTS = "/investments/events";
export const BUYFARM_PLANT =  `/transactions/farm-for-me`;

// export const INVEST_FROM_WALLET = "/transaction/invest-from-wallect";
export const REQUEST_PACKAGE = "/investments/farmrequest";
export const FARM_PACKAGES = "/packages/farmpackages";
export const FARM_SUBSCRIPTIONS = "/investments/farmsubscriptions";
export const FARM_REQUESTS = "/investments/farmrequests";
export const FARM_FROM_WALLET = `${TRANSACTIONS}/farm-from-wallet`;

export const INITIATE_PAYMENT = "/payments/initiate";
export const EDIBLES_PRODUCTS = "/edibles";
export const PENDING_EDIBLE_ORDERS = "/edibles/orders/pending"
export const ORDERED_EDIBLES_PRODUCTS = "/edibles/orders";

export const EDIBLES_MANUAL_PAYMENT = '/payments/edibles'
export const INDIVIDUAL_FARMANAGEMENT = (id) =>
  `/investments/farmsubscription/${id}`;
  export const SEARCH_EDIBLES = (searchedData) =>
  `/edibles/search/${searchedData}`;

  export const GET_DELIVERY_COST = '/edibles/delivery-cost'


